/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockTenderListCtrl
 */
angular.module('mercury.modules.stock.tender')
.controller('StockTenderListCtrl', ["dialog", "$scope", "StockTenders", "title", function(dialog, $scope, StockTenders, title) {
  title.set('Supplier Tenders');

  $scope.tenders = StockTenders.getAll();

  $scope.deleteTender = function(tender, index) {
    StockTenders.remove(tender)
    .then(function() {
      $scope.tenders.splice(index);
    });
  };
}]);
